import React from 'react';
import { FaCheck } from 'react-icons/fa';

// Shared full-screen-style list rendering used by Language/State screens and PickerModal.
const PickerList = ({ options, selected, onSelect }) => (
  <div style={{ padding: '16px' }}>
    {options.map((option, index) => {
      const isSelected = selected === option;
      return (
        <div key={option}>
          <div
            onClick={() => onSelect(option)}
            style={{
              padding: '12px 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <span
              style={{
                fontSize: '16px',
                color: isSelected ? '#094268' : '#222',
                fontWeight: isSelected ? 700 : 400,
              }}
            >
              {option}
            </span>
            {isSelected && <FaCheck size={16} color="#094268" />}
          </div>
          {index !== options.length - 1 && (
            <div style={{ height: '1px', background: '#ddd' }} />
          )}
        </div>
      );
    })}
  </div>
);

export default PickerList;
